import useApi from "@/composables/useApi";
import { YYYYMMDD } from "@/helpers/dateHelpers";
import { SailingsUpdateDepartureResponse } from "@/models/api/SailingsUpdateDepartureResponse";
import { SailingTypesEnum } from "@/types/Enums";
import { keepPreviousData, useQuery } from "@tanstack/vue-query";
import { computed, Ref } from "vue";

const useDeparturesQuery = (route: Ref<number>, selectedDate: Ref<Date>) => {
    const { post } = useApi();

    const request = computed(() => {
        return { route: route.value, date: YYYYMMDD(selectedDate.value), sailingType: SailingTypesEnum.Freight };
    });

    const getDepartures = () => {
        return post<SailingsUpdateDepartureResponse[]>("/api/SailingManager/GetSailings", request.value).then((resp) => {
            return resp.data ?? [];
        });
    };

    const queryKey = computed(() => ["getDepartures", request]);

    return {
        ...useQuery({
            queryKey: queryKey,
            enabled: computed(() => !!request.value),
            queryFn: getDepartures,
            refetchOnWindowFocus: false,
            retry: false,
            placeholderData: keepPreviousData,
        }),
    };
};

export default useDeparturesQuery;
